import React from "react";

import { BrowserRouter, Outlet, Routes, Route } from "react-router-dom";

import Footer from "./components/base/Footer";
import NavBar from "./components/base/Navbar";
import Home from "./Home";

function PrivateRouter() {
  return (
    <Routes>
      <Route
        element={
          <>
            <NavBar />
            <div
              style={{ position: "relative", minHeight: `calc(100vh - 135px)` }}
            >
              <Outlet />
            </div>
            <Footer />
          </>
        }
      >
        <Route path="/" element={<Home />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <PrivateRouter />
    </BrowserRouter>
  );
}
export default App;
